module.exports = "/_next/static/images/BadgeUnitedKingdom@2x-71c5c700e1c7fbe15b9274407cb310ca.png";